import useSWR, { SWRConfiguration } from 'swr';

import { GetAllAsync } from '../../services/api';
import { KendoGridResult } from '../../types/KendoGridResult';
import { ExternalEvent } from '../../types/external-event';

const ExternalEventsEndpoint = 'external-events';

export const useGetExternalEvents = (
  params?: string,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<KendoGridResult<ExternalEvent>>(
    `${ExternalEventsEndpoint}?${params}`,
    GetAllAsync,
    options
  );

  if (error) console.log(error);

  return {
    eventsData: data ?? { data: [], total: 0 },
    isLoading,
    isError: error,
    mutate
  };
};
